import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import qs from 'qs';
import { parseISO } from 'date-fns';

import { API_URL, get } from 'lib/network/api';
import CardContentPackage from './ComponentsPage/CardContentPackage';
import Tabs from 'components/Tabs';

const fetchMyPackage = async () => {
  const queryString = qs.stringify({ category: 'exclude_class' });
  return get(`${API_URL}/api/user/membership?${queryString}`);
};

const filterPackagesByStatus = (packages, isActive) => {
  if (!packages || !Array.isArray(packages)) return [];

  const now = new Date();
  now.setHours(0, 0, 0, 0); // Start of today

  return packages.filter((pkg) => {
    try {
      // Handle null or undefined active_until -> always active
      if (!pkg.active_until) {
        return isActive;
      }

      // Handle magic date (0001-01-01) -> always active
      const isUnlimited =
        typeof pkg.active_until === 'string' && pkg.active_until.startsWith('0001-01-01');
      if (isUnlimited) {
        return isActive;
      }

      const activeUntil = parseISO(pkg.active_until);
      if (Number.isNaN(activeUntil.getTime())) {
        return isActive;
      }

      // Expired only if active_until is before today (not including today)
      activeUntil.setHours(0, 0, 0, 0);
      const isExpired = activeUntil < now;

      return isActive ? !isExpired : isExpired;
    } catch (error) {
      console.error('Error parsing active_until date:', error);
      return isActive;
    }
  });
};

const MyPackagePlay = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get('status') || 'active';

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    const newStatus = tabId === 0 ? 'active' : 'inactive';
    setSearchParams({ status: newStatus });
  };

  useEffect(() => {
    if (status === 'active') setActiveTab(0);
    if (status === 'inactive') setActiveTab(1);
  }, [status]);

  const { data, isLoading, isError } = useQuery({
    queryKey: ['myPackagePlay'],
    queryFn: fetchMyPackage,
  });

  const activePackages = filterPackagesByStatus(data, true);
  const expiredPackages = filterPackagesByStatus(data, false);

  const tabs = [
    {
      id: 0,
      name: 'Active',
      content: <CardContentPackage data={activePackages} isLoading={isLoading} isError={isError} />,
    },
    {
      id: 1,
      name: 'Expired',
      content: (
        <CardContentPackage data={expiredPackages} isLoading={isLoading} isError={isError} />
      ),
    },
  ];

  return (
    <div>
      <h2 className="text-xl font-semibold">My Play & Exhibtion Passes</h2>
      <Tabs tabs={tabs} activeTab={activeTab} handleTabClick={handleTabClick} />
    </div>
  );
};

export default MyPackagePlay;
